module.exports = __webpack_public_path__ + "img/bg-winner.51f39ef9.svg";